import React from 'react';
import AuthDispatchContext from './AuthDispatchContext';

export default function useFunctions()
{
    return React.useContext(AuthDispatchContext);
}